import React from 'react';

const StorageErrorPage = () => (
  <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100 flex items-center justify-center px-4">
    <div className="max-w-2xl bg-white dark:bg-gray-800 shadow-md rounded-xl p-6 border-t-4 border-green-600">
      <h1 className="text-2xl font-bold text-green-700 mb-4">LocalStorage deaktiviert</h1>

      <p className="mb-4">
        Leider kannst du dieses Forum nicht nutzen, da dein Browser den Zugriff auf lokalen Speicher
        (<code className="bg-gray-200 dark:bg-gray-700 px-1 rounded text-sm">localStorage</code>) blockiert.
      </p>

      <h2 className="text-xl font-semibold mt-6 mb-2">Was ist localStorage?</h2>
      <p className="mb-4">
        <strong>localStorage</strong> ist ein sicherer, lokaler Speicher im Browser, mit dem Webseiten z. B. merken können,
        ob du eingeloggt bist. Die Daten bleiben <strong>nur auf deinem Gerät</strong> und werden <strong>nicht an Dritte oder Server gesendet</strong>.
      </p>

      <p className="mb-4">
        Dieses Forum verwendet localStorage nur für technische Zwecke – wie z. B. Login-Status oder Design-Einstellungen.
        Es werden <strong>keine persönlichen Daten gespeichert</strong>.
      </p>

      <h3 className="text-lg font-semibold mt-6 mb-2">Wie kannst du localStorage aktivieren?</h3>
      <ul className="list-disc list-inside space-y-2">
        <li>
          <strong>Chrome:</strong> Einstellungen &gt; Datenschutz &amp; Sicherheit &gt; Website-Einstellungen &gt;
          Cookies und Website-Daten → „Speichern und Lesen von Cookie-Daten zulassen“
        </li>
        <li>
          <strong>Firefox:</strong> Einstellungen &gt; Datenschutz &amp; Sicherheit &gt; Cookies und Website-Daten →
          Speicherzugriff erlauben
        </li>
        <li>
          <strong>Safari (iOS):</strong> Einstellungen &gt; Safari &gt; „Alle Cookies blockieren“ deaktivieren
        </li>
      </ul>

      <p className="mt-6">
        Lade die Seite neu, nachdem du die Einstellung geändert hast.
      </p>
    </div>
  </div>
);

export default StorageErrorPage;
